/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function TextListInputController(this: JS5Object, _: JS5Object, $timeout: JS5Function) {
	this.canAddItem = () => {
		let canAdd = true;
		_.forEach(this.items, (item: JS5Object) => {
			if (item.stringValue === '') {
				canAdd = false;
			}
		});
		return canAdd;
	};

	this.selectAll = () => {
		let enableDisable = (active: boolean) => {
			_.forEach(this.items, (item: JS5Object) => {
				item.active = active;
			});
		};

		if (this.selectAllActive) {
			enableDisable(true);
		} else {
			enableDisable(false);
		}
	};

	this.addStringItem = (event: JS5Object): void => {
		this.errors = false;

		if (!this.items) {
			this.items = [];
		}
		this.items.push({stringValue: ''});

		$timeout(() => {
			angular.element(`#${this.name}_stringInput_${this.items.length - 1}`).focus();
		});
	};

	this.removeStringItem = (): void => {
		if (!_.isEmpty(this.items)) {
			_.pullAllBy(this.items, [{active: true}], 'active');
			this.form.$setDirty();
		}

		if (_.isEmpty(this.items)) {
			this.errors = false;
			this.onUpdate({
				event: {
					name: this.name,
					items: undefined,
					errors: this.errors
				}
			});
		} else {
			this.updateModel();
		}
		this.selectAllActive = false;
	};

	this.updateModel = (event: JS5Object) => {
		this.onUpdate({
			event: {
				name: this.name,
				items: this.items,
				errors: this.errors
			}
		});
	};

    this.$onChanges = (changes: JS5Object): any => {
        if (changes.items && changes.items.currentValue) {
            let changedItems = _.cloneDeep(changes.items.currentValue);
            this.items.splice(0, this.items.length);
            _.forEach(changedItems, (changedItem: JS5Object) => {
                this.items.push(changedItem);
            });
        }
    };
}

angular.module('prism-ui.components').component('textListInput', {
	templateUrl: `components/visual/textListInput/text-list-input-template.html`,
	controller: TextListInputController,
	bindings: {
		name: '@',
		componentDisabled: '=ngDisabled',
		items: '<',
		onUpdate: '&'
	},
	require: {
		form: '?^form'
	}
});
